import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../redux/slices/postSlice";
import PostRow from "./PostRow";

const PostTable = ({ onPostClick, tableMode, refreshTrigger, formState }) => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.posts.posts);

  useEffect(() => {
    dispatch(fetchPosts(0));
  }, [dispatch, refreshTrigger, formState]);

  let filteredPosts = posts
    .filter((post) => post.status === "CREATED")
    .filter((post) =>
      tableMode === "buy"
        ? post.user_id !== user.data.id
        : post.user_id === user.data.id
    );
  if (formState?.sellCurrency && formState?.buyCurrency) {
    filteredPosts = filteredPosts.filter(
      (post) =>
        post.primary_currency === formState.sellCurrency &&
        post.secondary_currency === formState.buyCurrency
    );
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-header border-0">
            <h4 className="card-title">
              {tableMode === "buy" ? "Posts You Can Buy" : "All Your Posts"}
            </h4>
          </div>
          <div className="card-body pt-0">
            <div className="transaction-table">
              <div className="table-responsive">
                <table className="table mb-0 table-responsive-sm">
                  {filteredPosts.length > 0 ? (
                    filteredPosts.map((post) => (
                      <PostRow
                        key={post.id}
                        primaryCurrency={post.primary_currency}
                        secondaryCurrency={post.secondary_currency}
                        account={
                          post.default_card ||
                          post.default_bank ||
                          "Unknown Source"
                        }
                        amount={post.amount}
                        rate={post.rate}
                        post={post}
                        onClick={(mode) => onPostClick(post, mode)}
                      />
                    ))
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="6" className="text-center text-muted py-4">
                          No posts available for selected currency pair.
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostTable;
